import { render } from "./experience-details.vue?vue&type=template&id=70818c04&scoped=true"
import script from "./experience-details.vue?vue&type=script&lang=js"
export * from "./experience-details.vue?vue&type=script&lang=js"

import "./experience-details.vue?vue&type=style&index=0&id=70818c04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70818c04"]])

export default __exports__